<template>
	<div>
		<el-dialog id="dialogMode" :fullscreen="true" :title="showFileDetail.name" :visible.sync="showFileMode" width="80%"
			top="5vh">
			<div id="showModeDiv">
				<div v-if="showFileDetail.fileType == 'image'" style="text-align: center;">
					<el-image :src="showFileDetail.url" ></el-image>
				</div>
				<div v-if="showFileDetail.fileType == 'word' || showFileDetail.fileType == 'excel' || showFileDetail.fileType == 'ppt'"
					style="height:83vh;">
					<iframe  :src="'https://view.officeapps.live.com/op/view.aspx?src='+showFileDetail.url"
						frameborder="0" height="100%;" width="100%;"></iframe>
				</div>
				<div  v-if="showFileDetail.fileType == 'pdf'" style="text-align: center;">
					<iframe  :src="'/pdfjs/web/viewer.html?file='+showFileDetail.url" style="border:0px;height:78vh;"frameborder="0" width="100%"></iframe>
				</div>
				<div v-if="showFileDetail.fileType == 'txt'" style="height:81vh;overflow:auto;">
					<pre >{{showFileDetail.txt}}</pre>
				</div>
			</div>
		</el-dialog>
		
		<el-card style="margin-right:10px;margin-bottom:10px;display:inline-block;font-weight: 500;" v-for="(item,index) in imageList">
			<div style="height:15px;width:auto;display:inline-block;">
				<div style="display:inline-block;">{{item.name}}</div>
				<el-link @click="showFile(item)" style="margin-left:8px;margin-right:8px;margin-top:13px;position:relative;bottom:7px;"
				icon="el-icon-search">在线查看</el-link>
				<el-link style="margin-right:8px;margin-top:13px;position:relative;bottom:7px;"
						@click="downloadFile(item)" icon="el-icon-download">下载</el-link>
			</div>
		</el-card>

	</div>


</template>
<script>
	import utils from '@/utils';
	export default {
		name: "ImageSelect",
        props: ['imageList'],
		data() {
			return {
				list: [],
				dialogImageUrl:"",
				imageDialogVisible:false,
				imageName:"",
				showFileDetail: {},
				showFileMode:false,
				
				dialogHeight:0,
				dialogWidth:0,
			}
		},
		methods: {
			
			downloadFile(file) {
				utils.sendTrace("下载文件：" + JSON.stringify(file));
				window.open(file.url);
			},
			getFileType(item){
				let fileType = utils.getFileType(item.url);
				if(fileType != null){
					return fileType;
				}else{
					return null;
				}
			},
			showFile(file) {
				file.fileType = utils.getFileType(file.url);
				if (file.fileType == "image" || file.fileType == "word" || file.fileType == "excel" || file.fileType ==
					"ppt") {
					this.showFileDetail = file;
					this.showFileMode = true;
				} else if (file.fileType == "pdf") {
					this.showFileDetail = file;
					this.showFileMode = true;
				} else if (file.fileType == "txt") {
					let mgs = this.$message({
						message: '正在加载TXT',
						type: "loading",
						iconClass: "el-icon-loading",
						duration: 99999
					});
					utils.httpRequest(file.url).then((data) => {
						file.txt = data;
						this.showFileDetail = file;
						this.showFileMode = true;
						mgs.close();
					}).catch(err => {
						console.log(err)
						mgs.close();
						this.$message({
							message: 'TXT加载失败',
							type: 'info',
						})
					})
				} else {
					this.$message({
						message: '此文件类型不支持预览',
						type: 'info',
					})
				}

			}
		},
		mounted() {
		}
	}
</script>
